// Complete translations for Perfect Team Renov - FR/EN
export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      projects: "Réalisations",
      quote: "Devis Gratuit",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      badge: "Excellence en Rénovation Intérieure",
      title1: "Perfect Team",
      title2: "Renov",
      description: "Transformez votre intérieur avec des artisans d'exception. Plafonnage, peinture, cloisons, sols - nous créons des espaces qui reflètent votre style de vie.",
      regions: "Bruxelles • Brabant Wallon • Brabant Flamand",
      cta_quote: "Devis Gratuit",
      cta_call: "Appelez-nous",
    },
    // Stats
    stats: {
      projects: "Projets Réalisés",
      experience: "Ans d'Expérience",
      satisfaction: "Satisfaction Client",
      regions: "Régions Couvertes",
    },
    // About
    about: {
      badge: "Qui Sommes-Nous",
      title1: "Perfect Team",
      title2: "Renov",
      description1: "Perfect Team Renov est une entreprise spécialisée dans les travaux de rénovation intérieure et de finitions. Nous réalisons différents types de travaux tels que plafonnage, peinture, cloisons gyproc, pose de sols et rénovation complète.",
      description2: "Notre objectif est de proposer un travail soigné, durable et réalisé dans les délais, avec une grande attention aux détails. Chaque projet est traité avec le même niveau d'exigence et de professionnalisme.",
      features: [
        "Travail soigné et finitions de qualité",
        "Respect des délais",
        "Devis clair et transparent",
        "Équipe professionnelle et expérimentée",
        "Intervention rapide",
        "Garantie satisfaction incluse",
      ],
      cta_services: "Nos Services",
      cta_projects: "Nos Réalisations",
      experience_badge: "Ans d'Excellence",
    },
    // Services
    services: {
      badge: "Nos Services",
      title1: "Services",
      title2: "Proposés",
      description: "De la préparation des surfaces aux finitions les plus raffinées, découvrez notre gamme complète de services de rénovation.",
      cta_all: "Tous Nos Services",
      items: {
        renovation: {
          title: "Rénovation Intérieure",
          description: "Transformation complète de votre espace de vie",
        },
        plastering: {
          title: "Plafonnage",
          description: "Enduits traditionnels et modernes pour des murs parfaits",
        },
        painting: {
          title: "Peinture",
          description: "Finitions professionnelles et effets décoratifs",
        },
        drywall: {
          title: "Cloisons Gyproc",
          description: "Aménagement d'espaces et isolation performante",
        },
        flooring: {
          title: "Pose de Sol",
          description: "Parquet et revêtements de sol de qualité",
        },
        bathroom: {
          title: "Salle de Bain",
          description: "Rénovation complète de salle de bain",
        },
      },
    },
    // Why Choose Us
    whyUs: {
      badge: "Pourquoi Nous Choisir",
      title1: "Nos",
      title2: "Engagements",
      description: "Ce qui nous distingue : un engagement total pour l'excellence et votre satisfaction.",
      items: {
        quality: {
          title: "Travail Soigné",
          description: "Finitions de qualité avec une grande attention aux détails.",
        },
        deadlines: {
          title: "Respect des Délais",
          description: "Nous nous engageons sur des délais précis et les respectons scrupuleusement.",
        },
        transparent: {
          title: "Devis Transparent",
          description: "Devis clair et détaillé, sans surprise ni frais cachés.",
        },
        team: {
          title: "Équipe Expérimentée",
          description: "Professionnels qualifiés avec des années d'expérience.",
        },
        fast: {
          title: "Intervention Rapide",
          description: "Disponibilité et réactivité pour tous vos projets.",
        },
      },
    },
    // Before/After
    beforeAfter: {
      badge: "Transformations",
      title1: "Avant",
      title2: "Après",
      description: "Découvrez la magie de nos transformations. Chaque projet témoigne de notre savoir-faire.",
      cta: "Voir Toutes les Réalisations",
      before: "Avant",
      after: "Après",
    },
    // Testimonials
    testimonials: {
      badge: "Témoignages",
      title1: "Ils Nous Font",
      title2: "Confiance",
      description: "La satisfaction de nos clients est notre meilleure référence.",
    },
    // CTA Section
    cta: {
      title1: "Prêt à Transformer",
      title2: "Votre Intérieur?",
      description: "Contactez-nous pour un devis gratuit et personnalisé. Notre équipe vous répond sous 24 heures.",
      button_quote: "Demander un Devis",
      button_call: "Appelez-nous",
      features: ["Devis gratuit", "Réponse en 24h", "Sans engagement"],
    },
    // Services Page
    servicesPage: {
      badge: "Nos Expertises",
      title1: "Services",
      title2: "d'Excellence",
      description: "De la préparation des surfaces aux finitions décoratives les plus raffinées, notre équipe maîtrise l'ensemble des métiers de la rénovation intérieure.",
      process: {
        badge: "Notre Processus",
        title1: "Comment Nous",
        title2: "Travaillons",
        steps: [
          { number: "01", title: "Contact", description: "Prenez contact par téléphone, email ou formulaire" },
          { number: "02", title: "Visite", description: "Visite gratuite sur site pour évaluer vos besoins" },
          { number: "03", title: "Devis", description: "Devis détaillé et transparent sous 48h" },
          { number: "04", title: "Planification", description: "Planning des travaux adapté à vos contraintes" },
          { number: "05", title: "Réalisation", description: "Exécution soignée par nos artisans qualifiés" },
          { number: "06", title: "Réception", description: "Vérification finale et garantie de satisfaction" },
        ],
      },
    },
    // Projects Page
    projectsPage: {
      badge: "Portfolio",
      title1: "Nos",
      title2: "Réalisations",
      description: "Découvrez nos projets de rénovation. Chaque réalisation témoigne de notre engagement pour la qualité.",
      filter: "Filtrer par",
      all: "Tous les projets",
      projects: "projets",
      viewBefore: "Voir Avant/Après",
      grid: "Grille",
      slider: "Avant/Après",
      featured: {
        badge: "Projet Vedette",
        title1: "L'Art de la",
        title2: "Métamorphose",
      },
      ctaTitle1: "Votre Projet Sera",
      ctaTitle2: "le Prochain?",
      ctaDescription: "Chaque projet est unique. Parlez-nous de vos idées et nous vous aiderons à les concrétiser.",
    },
    // Quote Page
    quotePage: {
      badge: "Devis Gratuit",
      title1: "Demandez",
      title2: "Votre Devis",
      description: "Remplissez le formulaire ci-dessous et recevez un devis personnalisé sous 24-48h. Sans engagement.",
      form: {
        name: "Nom complet",
        namePlaceholder: "Votre nom",
        phone: "Téléphone",
        phonePlaceholder: "+32 XXX XX XX XX",
        email: "Email",
        emailPlaceholder: "votre@email.com",
        workType: "Type de travaux",
        workTypePlaceholder: "Sélectionnez le type de travaux",
        description: "Description du projet",
        descriptionPlaceholder: "Décrivez votre projet en détail: surface, état actuel, souhaits particuliers...",
        photos: "Photos (optionnel)",
        photosInfo: "Max 5 photos, 5MB chacune",
        submit: "Envoyer la Demande",
        submitting: "Envoi en cours...",
      },
      workTypes: [
        "Plafonnage",
        "Peinture Intérieure",
        "Cloisons Gyproc",
        "Pose de Sol",
        "Finitions Décoratives",
        "Rénovation Complète",
        "Autre",
      ],
      success: {
        title: "Demande Envoyée!",
        message: "Merci pour votre demande. Notre équipe vous contactera dans les plus brefs délais.",
        urgent: "Pour toute question urgente:",
        newRequest: "Nouvelle Demande",
      },
      sidebar: {
        contact: "Contact Direct",
        process: "Notre Processus",
        processSteps: [
          { step: "1", title: "Demande", text: "Envoyez votre demande" },
          { step: "2", title: "Contact", text: "Nous vous appelons sous 24h" },
          { step: "3", title: "Visite", text: "Visite gratuite sur site" },
          { step: "4", title: "Devis", text: "Devis détaillé personnalisé" },
        ],
        guarantee: "Notre Garantie",
        guaranteeItems: [
          "Devis gratuit et sans engagement",
          "Prix transparents, pas de surprises",
          "Travaux garantis",
          "Satisfaction client prioritaire",
        ],
      },
    },
    // Contact Page
    contactPage: {
      badge: "Contact",
      title1: "Parlons de",
      title2: "Votre Projet",
      description: "Une question? Un projet? Nous sommes à votre écoute.",
      info: {
        phone: "Téléphone",
        email: "Email",
        address: "Adresse",
        hours: "Horaires",
        hoursValue: "Lun - Ven: 8h - 18h | Sam: 9h - 14h",
      },
      form: {
        title: "Envoyez-nous un Message",
        name: "Nom",
        namePlaceholder: "Votre nom",
        email: "Email",
        emailPlaceholder: "votre@email.com",
        phone: "Téléphone",
        phonePlaceholder: "+32 XXX XX XX XX",
        message: "Message",
        messagePlaceholder: "Comment pouvons-nous vous aider?",
        submit: "Envoyer le Message",
        submitting: "Envoi en cours...",
      },
      company: {
        vat: "TVA",
        contact: "Contact",
        description: "Spécialistes en travaux de finition et rénovation intérieure depuis plus de 15 ans.",
      },
      whatsapp: {
        title: "WhatsApp",
        subtitle: "Réponse rapide garantie",
        description: "Contactez-nous directement via WhatsApp pour une réponse immédiate.",
        button: "Ouvrir WhatsApp",
      },
      call: {
        title: "Appelez-Nous",
        description: "Pour une réponse immédiate ou pour discuter de votre projet.",
      },
      areas: {
        badge: "Zone d'Intervention",
        title: "Nous Intervenons Dans",
        items: [
          { name: "Bruxelles", description: "Toutes les communes de la région bruxelloise" },
          { name: "Sint-Pieters-Leeuw", description: "Et communes environnantes" },
          { name: "Anderlecht", description: "Et quartiers limitrophes" },
          { name: "Uccle", description: "Et communes du sud de Bruxelles" },
          { name: "Waterloo", description: "Et Brabant Wallon" },
          { name: "Brabant Flamand", description: "Leuven, Halle et environs" },
        ],
      },
      visit: "Visitez-Nous",
    },
    // Footer
    footer: {
      description: "Spécialistes en travaux de finition et rénovation intérieure. Qualité, professionnalisme et satisfaction client garantis.",
      services: "Nos Services",
      navigation: "Navigation",
      contact: "Contact",
      serviceArea: "Zone d'intervention",
      rights: "Tous droits réservés.",
    },
    // Common
    common: {
      learnMore: "En Savoir Plus",
      viewAll: "Voir Tout",
      requestQuote: "Demander un Devis",
      freeQuote: "Devis Gratuit",
      location: "Localisation",
      category: "Catégorie",
    },
  },

  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      projects: "Projects",
      quote: "Free Quote",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      badge: "Excellence in Interior Renovation",
      title1: "Perfect Team",
      title2: "Renov",
      description: "Transform your interior with exceptional craftsmen. Plastering, painting, partitions, flooring - we create spaces that reflect your lifestyle.",
      regions: "Brussels • Walloon Brabant • Flemish Brabant",
      cta_quote: "Free Quote",
      cta_call: "Call Us",
    },
    // Stats
    stats: {
      projects: "Completed Projects",
      experience: "Years of Experience",
      satisfaction: "Client Satisfaction",
      regions: "Regions Covered",
    },
    // About
    about: {
      badge: "About Us",
      title1: "Perfect Team",
      title2: "Renov",
      description1: "Perfect Team Renov is a company specializing in interior renovation and finishing work. We carry out various types of work such as plastering, painting, drywall partitions, flooring and complete renovation.",
      description2: "Our goal is to offer careful, durable work completed on time, with great attention to detail. Each project is treated with the same level of standards and professionalism.",
      features: [
        "Careful work and quality finishes",
        "Meeting deadlines",
        "Clear and transparent quotes",
        "Professional and experienced team",
        "Quick response",
        "Satisfaction guarantee included",
      ],
      cta_services: "Our Services",
      cta_projects: "Our Projects",
      experience_badge: "Years of Excellence",
    },
    // Services
    services: {
      badge: "Our Services",
      title1: "Services",
      title2: "Offered",
      description: "From surface preparation to the finest finishes, discover our complete range of renovation services.",
      cta_all: "All Our Services",
      items: {
        renovation: {
          title: "Interior Renovation",
          description: "Complete transformation of your living space",
        },
        plastering: {
          title: "Plastering",
          description: "Traditional and modern renders for perfect walls",
        },
        painting: {
          title: "Painting",
          description: "Professional finishes and decorative effects",
        },
        drywall: {
          title: "Drywall",
          description: "Space planning and efficient insulation",
        },
        flooring: {
          title: "Flooring",
          description: "Parquet and quality floor coverings",
        },
        bathroom: {
          title: "Bathroom",
          description: "Complete bathroom renovation",
        },
      },
    },
    // Why Choose Us
    whyUs: {
      badge: "Why Choose Us",
      title1: "Our",
      title2: "Commitments",
      description: "What sets us apart: a total commitment to excellence and your satisfaction.",
      items: {
        quality: {
          title: "Careful Work",
          description: "Quality finishes with great attention to detail.",
        },
        deadlines: {
          title: "Meeting Deadlines",
          description: "We commit to precise deadlines and respect them.",
        },
        transparent: {
          title: "Transparent Quotes",
          description: "Clear and detailed quotes, no surprises or hidden fees.",
        },
        team: {
          title: "Experienced Team",
          description: "Qualified professionals with years of experience.",
        },
        fast: {
          title: "Quick Response",
          description: "Availability and responsiveness for all your projects.",
        },
      },
    },
    // Before/After
    beforeAfter: {
      badge: "Transformations",
      title1: "Before",
      title2: "After",
      description: "Discover the magic of our transformations. Each project showcases our expertise.",
      cta: "View All Projects",
      before: "Before",
      after: "After",
    },
    // Testimonials
    testimonials: {
      badge: "Testimonials",
      title1: "They Trust",
      title2: "Us",
      description: "Client satisfaction is our best reference.",
    },
    // CTA Section
    cta: {
      title1: "Ready to Transform",
      title2: "Your Interior?",
      description: "Contact us for a free, personalized quote. Our team responds within 24 hours.",
      button_quote: "Request a Quote",
      button_call: "Call Us",
      features: ["Free quote", "24h response", "No commitment"],
    },
    // Services Page
    servicesPage: {
      badge: "Our Expertise",
      title1: "Services of",
      title2: "Excellence",
      description: "From surface preparation to the finest decorative finishes, our team masters all interior renovation trades.",
      process: {
        badge: "Our Process",
        title1: "How We",
        title2: "Work",
        steps: [
          { number: "01", title: "Contact", description: "Reach out by phone, email or form" },
          { number: "02", title: "Visit", description: "Free on-site visit to assess your needs" },
          { number: "03", title: "Quote", description: "Detailed and transparent quote within 48h" },
          { number: "04", title: "Planning", description: "Work schedule adapted to your constraints" },
          { number: "05", title: "Execution", description: "Careful work by our skilled craftsmen" },
          { number: "06", title: "Handover", description: "Final inspection and satisfaction guarantee" },
        ],
      },
    },
    // Projects Page
    projectsPage: {
      badge: "Portfolio",
      title1: "Our",
      title2: "Projects",
      description: "Discover our renovation projects. Each achievement demonstrates our commitment to quality.",
      filter: "Filter by",
      all: "All projects",
      projects: "projects",
      viewBefore: "View Before/After",
      grid: "Grid",
      slider: "Before/After",
      featured: {
        badge: "Featured Project",
        title1: "The Art of",
        title2: "Transformation",
      },
      ctaTitle1: "Your Project Could Be",
      ctaTitle2: "Next?",
      ctaDescription: "Every project is unique. Tell us about your ideas and we'll help bring them to life.",
    },
    // Quote Page
    quotePage: {
      badge: "Free Quote",
      title1: "Request",
      title2: "Your Quote",
      description: "Fill out the form below and receive a personalized quote within 24-48h. No commitment.",
      form: {
        name: "Full name",
        namePlaceholder: "Your name",
        phone: "Phone",
        phonePlaceholder: "+32 XXX XX XX XX",
        email: "Email",
        emailPlaceholder: "your@email.com",
        workType: "Type of work",
        workTypePlaceholder: "Select the type of work",
        description: "Project description",
        descriptionPlaceholder: "Describe your project in detail: surface area, current condition, specific wishes...",
        photos: "Photos (optional)",
        photosInfo: "Max 5 photos, 5MB each",
        submit: "Send Request",
        submitting: "Sending...",
      },
      workTypes: [
        "Plastering",
        "Interior Painting",
        "Drywall Partitions",
        "Flooring",
        "Decorative Finishes",
        "Complete Renovation",
        "Other",
      ],
      success: {
        title: "Request Sent!",
        message: "Thank you for your request. Our team will contact you shortly.",
        urgent: "For urgent questions:",
        newRequest: "New Request",
      },
      sidebar: {
        contact: "Direct Contact",
        process: "Our Process",
        processSteps: [
          { step: "1", title: "Request", text: "Send your request" },
          { step: "2", title: "Contact", text: "We call you within 24h" },
          { step: "3", title: "Visit", text: "Free on-site visit" },
          { step: "4", title: "Quote", text: "Personalized detailed quote" },
        ],
        guarantee: "Our Guarantee",
        guaranteeItems: [
          "Free quote with no commitment",
          "Transparent pricing, no surprises",
          "Guaranteed work",
          "Customer satisfaction priority",
        ],
      },
    },
    // Contact Page
    contactPage: {
      badge: "Contact",
      title1: "Let's Discuss",
      title2: "Your Project",
      description: "Have a question? A project? We're here to help.",
      info: {
        phone: "Phone",
        email: "Email",
        address: "Address",
        hours: "Hours",
        hoursValue: "Mon - Fri: 8am - 6pm | Sat: 9am - 2pm",
      },
      form: {
        title: "Send Us a Message",
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "your@email.com",
        phone: "Phone",
        phonePlaceholder: "+32 XXX XX XX XX",
        message: "Message",
        messagePlaceholder: "How can we help you?",
        submit: "Send Message",
        submitting: "Sending...",
      },
      company: {
        vat: "VAT",
        contact: "Contact",
        description: "Specialists in finishing work and interior renovation for over 15 years.",
      },
      whatsapp: {
        title: "WhatsApp",
        subtitle: "Quick response guaranteed",
        description: "Contact us directly via WhatsApp for an immediate response.",
        button: "Open WhatsApp",
      },
      call: {
        title: "Call Us",
        description: "For an immediate response or to discuss your project.",
      },
      areas: {
        badge: "Service Area",
        title: "We Operate In",
        items: [
          { name: "Brussels", description: "All municipalities in the Brussels region" },
          { name: "Walloon Brabant", description: "Wavre, Ottignies, Nivelles and surroundings" },
          { name: "Flemish Brabant", description: "Leuven, Sint-Pieters-Leeuw, Halle and surroundings" },
        ],
      },
      visit: "Visit Us",
    },
    // Footer
    footer: {
      description: "Specialists in finishing work and interior renovation. Quality, professionalism and customer satisfaction guaranteed.",
      services: "Our Services",
      navigation: "Navigation",
      contact: "Contact",
      serviceArea: "Service area",
      rights: "All rights reserved.",
    },
    // Common
    common: {
      learnMore: "Learn More",
      viewAll: "View All",
      requestQuote: "Request Quote",
      freeQuote: "Free Quote",
      location: "Location",
      category: "Category",
    },
  },

  nl: {
    // Navigation
    nav: {
      home: "Home",
      services: "Diensten",
      projects: "Projecten",
      quote: "Gratis Offerte",
      contact: "Contact",
    },
    // Hero Section
    hero: {
      badge: "Uitmuntendheid in Binnenrenovatie",
      title1: "Perfect Team",
      title2: "Renov",
      description: "Transformeer uw interieur met uitzonderlijke vakmanschap. Pleisterwerk, schilderwerk, scheidingswanden, vloeren - wij creëren ruimtes die uw levensstijl weerspiegelen.",
      regions: "Heel België",
      cta_quote: "Gratis Offerte",
      cta_call: "Bel Ons",
    },
    // Stats
    stats: {
      projects: "Voltooide Projecten",
      experience: "Jaar Ervaring",
      satisfaction: "Klanttevredenheid",
      regions: "Heel België",
    },
    // About
    about: {
      badge: "Over Ons",
      title1: "Perfect Team",
      title2: "Renov",
      description1: "Perfect Team Renov is een bedrijf gespecialiseerd in binnenrenovatie en afwerkingswerken. Wij voeren verschillende soorten werken uit zoals pleisterwerk, schilderwerk, gyproc scheidingswanden, vloeren en volledige renovatie.",
      description2: "Ons doel is om zorgvuldig, duurzaam werk te leveren dat op tijd wordt afgerond, met grote aandacht voor detail. Elk project wordt behandeld met hetzelfde niveau van normen en professionalisme.",
      features: [
        "Zorgvuldig werk en kwaliteitsafwerking",
        "Respecteren van deadlines",
        "Duidelijke en transparante offertes",
        "Professioneel en ervaren team",
        "Snelle respons",
        "Tevredenheidsgarantie inbegrepen",
      ],
      cta_services: "Onze Diensten",
      cta_projects: "Onze Projecten",
      experience_badge: "Jaar Ervaring",
    },
    // Services
    services: {
      badge: "Onze Diensten",
      title1: "Aangeboden",
      title2: "Diensten",
      description: "Van oppervlaktevoorbereiding tot de fijnste afwerkingen, ontdek ons complete aanbod van renovatiediensten.",
      cta_all: "Alle Diensten",
      items: {
        renovation: {
          title: "Binnenrenovatie",
          description: "Complete transformatie van uw leefruimte",
        },
        plastering: {
          title: "Pleisterwerk",
          description: "Traditionele en moderne afwerkingen voor perfecte muren",
        },
        painting: {
          title: "Schilderwerk",
          description: "Professionele afwerkingen en decoratieve effecten",
        },
        drywall: {
          title: "Gyproc Wanden",
          description: "Ruimteplanning en efficiënte isolatie",
        },
        flooring: {
          title: "Vloeren",
          description: "Parket en kwaliteits vloerbekleding",
        },
        bathroom: {
          title: "Badkamer",
          description: "Complete badkamerrenovatie",
        },
      },
    },
    // Why Choose Us
    whyUs: {
      badge: "Waarom Ons Kiezen",
      title1: "Onze",
      title2: "Engagementen",
      description: "Wat ons onderscheidt: een totale inzet voor uitmuntendheid en uw tevredenheid.",
      items: {
        quality: {
          title: "Zorgvuldig Werk",
          description: "Kwaliteitsafwerkingen met grote aandacht voor detail.",
        },
        deadlines: {
          title: "Deadlines Respecteren",
          description: "Wij engageren ons voor precieze deadlines en respecteren ze.",
        },
        transparent: {
          title: "Transparante Offertes",
          description: "Duidelijke en gedetailleerde offertes, geen verrassingen of verborgen kosten.",
        },
        team: {
          title: "Ervaren Team",
          description: "Gekwalificeerde professionals met jarenlange ervaring.",
        },
        fast: {
          title: "Snelle Respons",
          description: "Beschikbaarheid en reactievermogen voor al uw projecten.",
        },
      },
    },
    // Before/After
    beforeAfter: {
      badge: "Transformaties",
      title1: "Voor",
      title2: "Na",
      description: "Ontdek de magie van onze transformaties. Elk project toont onze expertise.",
      cta: "Alle Projecten Bekijken",
      before: "Voor",
      after: "Na",
    },
    // Testimonials
    testimonials: {
      badge: "Getuigenissen",
      title1: "Ze Vertrouwen",
      title2: "Ons",
      description: "Klanttevredenheid is onze beste referentie.",
    },
    // CTA Section
    cta: {
      title1: "Klaar om Uw",
      title2: "Interieur te Transformeren?",
      description: "Neem contact met ons op voor een gratis, gepersonaliseerde offerte. Ons team antwoordt binnen 24 uur.",
      button_quote: "Offerte Aanvragen",
      button_call: "Bel Ons",
      features: ["Gratis offerte", "24u respons", "Zonder verplichting"],
    },
    // Services Page
    servicesPage: {
      badge: "Onze Expertise",
      title1: "Diensten van",
      title2: "Uitmuntendheid",
      description: "Van oppervlaktevoorbereiding tot de fijnste decoratieve afwerkingen, ons team beheerst alle renovatievakken.",
      process: {
        badge: "Ons Proces",
        title1: "Hoe Wij",
        title2: "Werken",
        steps: [
          { number: "01", title: "Contact", description: "Neem contact op via telefoon, e-mail of formulier" },
          { number: "02", title: "Bezoek", description: "Gratis bezoek ter plaatse om uw behoeften te beoordelen" },
          { number: "03", title: "Offerte", description: "Gedetailleerde en transparante offerte binnen 48u" },
          { number: "04", title: "Planning", description: "Werkplanning aangepast aan uw beperkingen" },
          { number: "05", title: "Uitvoering", description: "Zorgvuldige uitvoering door onze vakkundige ambachtslieden" },
          { number: "06", title: "Oplevering", description: "Eindcontrole en tevredenheidsgarantie" },
        ],
      },
    },
    // Projects Page
    projectsPage: {
      badge: "Portfolio",
      title1: "Onze",
      title2: "Projecten",
      description: "Ontdek onze renovatieprojecten. Elke realisatie toont onze inzet voor kwaliteit.",
      filter: "Filteren op",
      all: "Alle projecten",
      projects: "projecten",
      viewBefore: "Bekijk Voor/Na",
      grid: "Raster",
      slider: "Voor/Na",
      featured: {
        badge: "Uitgelicht Project",
        title1: "De Kunst van",
        title2: "Transformatie",
      },
      ctaTitle1: "Uw Project Kan",
      ctaTitle2: "Het Volgende Zijn?",
      ctaDescription: "Elk project is uniek. Vertel ons over uw ideeën en wij helpen ze te realiseren.",
    },
    // Quote Page
    quotePage: {
      badge: "Gratis Offerte",
      title1: "Vraag",
      title2: "Uw Offerte",
      description: "Vul het onderstaande formulier in en ontvang een gepersonaliseerde offerte binnen 24-48u. Zonder verplichting.",
      form: {
        name: "Volledige naam",
        namePlaceholder: "Uw naam",
        phone: "Telefoon",
        phonePlaceholder: "+32 XXX XX XX XX",
        email: "E-mail",
        emailPlaceholder: "uw@email.com",
        workType: "Type werk",
        workTypePlaceholder: "Selecteer het type werk",
        description: "Projectbeschrijving",
        descriptionPlaceholder: "Beschrijf uw project in detail: oppervlakte, huidige staat, specifieke wensen...",
        photos: "Foto's (optioneel)",
        photosInfo: "Max 5 foto's, 5MB elk",
        submit: "Aanvraag Verzenden",
        submitting: "Verzenden...",
      },
      workTypes: [
        "Pleisterwerk",
        "Binnenschilderwerk",
        "Gyproc Scheidingswanden",
        "Vloeren",
        "Decoratieve Afwerkingen",
        "Volledige Renovatie",
        "Andere",
      ],
      success: {
        title: "Aanvraag Verzonden!",
        message: "Bedankt voor uw aanvraag. Ons team neemt binnenkort contact met u op.",
        urgent: "Voor dringende vragen:",
        newRequest: "Nieuwe Aanvraag",
      },
      sidebar: {
        contact: "Direct Contact",
        process: "Ons Proces",
        processSteps: [
          { step: "1", title: "Aanvraag", text: "Verzend uw aanvraag" },
          { step: "2", title: "Contact", text: "Wij bellen u binnen 24u" },
          { step: "3", title: "Bezoek", text: "Gratis bezoek ter plaatse" },
          { step: "4", title: "Offerte", text: "Gepersonaliseerde gedetailleerde offerte" },
        ],
        guarantee: "Onze Garantie",
        guaranteeItems: [
          "Gratis offerte zonder verplichting",
          "Transparante prijzen, geen verrassingen",
          "Gegarandeerd werk",
          "Klanttevredenheid prioriteit",
        ],
      },
    },
    // Contact Page
    contactPage: {
      badge: "Contact",
      title1: "Laten We Praten",
      title2: "Over Uw Project",
      description: "Een vraag? Een project? Wij staan voor u klaar.",
      info: {
        phone: "Telefoon",
        email: "E-mail",
        address: "Adres",
        hours: "Openingsuren",
        hoursValue: "Ma - Vr: 8u - 18u | Za: 9u - 14u",
      },
      form: {
        title: "Stuur Ons een Bericht",
        name: "Naam",
        namePlaceholder: "Uw naam",
        email: "E-mail",
        emailPlaceholder: "uw@email.com",
        phone: "Telefoon",
        phonePlaceholder: "+32 XXX XX XX XX",
        message: "Bericht",
        messagePlaceholder: "Hoe kunnen wij u helpen?",
        submit: "Bericht Verzenden",
        submitting: "Verzenden...",
      },
      company: {
        vat: "BTW",
        contact: "Contact",
        description: "Specialisten in afwerkingswerk en binnenrenovatie sinds meer dan 15 jaar.",
      },
      whatsapp: {
        title: "WhatsApp",
        subtitle: "Snelle respons gegarandeerd",
        description: "Neem rechtstreeks contact met ons op via WhatsApp voor een onmiddellijk antwoord.",
        button: "WhatsApp Openen",
      },
      call: {
        title: "Bel Ons",
        description: "Voor een onmiddellijk antwoord of om uw project te bespreken.",
      },
      areas: {
        badge: "Werkgebied",
        title: "Wij Werken In",
        items: [
          { name: "Heel België", description: "Wij werken in alle regio's van België" },
        ],
      },
      visit: "Bezoek Ons",
    },
    // Footer
    footer: {
      description: "Specialisten in afwerkingswerk en binnenrenovatie. Kwaliteit, professionalisme en klanttevredenheid gegarandeerd.",
      services: "Onze Diensten",
      navigation: "Navigatie",
      contact: "Contact",
      serviceArea: "Werkgebied",
      rights: "Alle rechten voorbehouden.",
    },
    // Common
    common: {
      learnMore: "Meer Weten",
      viewAll: "Alles Bekijken",
      requestQuote: "Offerte Aanvragen",
      freeQuote: "Gratis Offerte",
      location: "Locatie",
      category: "Categorie",
    },
  },
};

export const defaultLanguage = "fr";

export const supportedLanguages = [
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "nl", name: "Nederlands", flag: "🇳🇱" },
];
